<script>
    export default{
        data() {
            return{
                dados: {}
            }
        },
        ready: function ()
        {
            var self = this;
            //json com os dados do header
            $.getJSON('./../server/footerservicos.php', function (dados)
            {
                self.dados = dados[0];
                //console.log(self.dados)

                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id))
                        return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//connect.facebook.net/pt_BR/all.js#xfbml=1";
                    fjs.parentNode.insertBefore(js, fjs);
                }
                (document, 'script', 'facebook-jssdk'));

            });
        }
    }
</script>

<template>
    <footer class="footer-1 bg-color-1">

        <!-- main footer begin -->
        <div class="main-footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12">
                        <div class="col-md-4 col-sm-4">
                            <div class="compact-widget">                                                
                                <div class="widget-inner">
                                    <p><div class="fb-like-box" :data-href="dados.facebook" data-width="239" data-height="205" data-show-faces="true" data-header="true" data-stream="false" data-show-border="false"></div></p>
                                    <div class="social-icons clearfix">
                                        <a :href="social.link" :class="social.classe" v-for="social in dados.social" target="_blank">
                                            <i :class="social.icone"></i>
                                        </a>
                                    </div>
                                </div>    
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4">
                            <div class="compact-widget">
                                <h3 class="widget-title">Menu Rapido</h3> 
                                <div class="widget-inner" style="">
                                    <ul>
                                        <li v-for="dado in dados.menurapido">
                                            <a :href="dado.link">{{dado.titulo}}</a>
                                        </li>
                                    </ul>
                                </div>                                  
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4">
                            <div class="compact-widget">
                                <h3 class="widget-title">Contatos</h3>
                                <div class="widget-inner">
                                    <p><i class="fa fa-home"></i> {{dados.endereco}}</p>
                                    <p v-for="tel in dados.telefones"><i class="fa fa-phone"></i> {{tel.telefone}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="copy-site">
                        <p>Copyright © 2015 - Todos os direitos reservados - Serviços ao Cidadão, Seu portal de serviços</p>
                        <p>Desenvolvido por <a title="M P Lopes" href="https://www.mplopes.com.br/" target="_blank">M P Lopes Sistemas de Informação</a></p>
                    </div>
                </div>
            </div>
        </div>            
        <!-- main footer close -->

    </footer>
</template>


// WEBPACK FOOTER //
// footer.vue?56cb0aaa